module.exports = __webpack_public_path__ + "static/media/rightdemo.51229718.png";